import {defaultsDeep} from 'es-toolkit/compat'

import defaultConfig from './default'

export default defaultsDeep(
  {
    sentry: {
      enabled: true,
      environment: 'production',
    },
    amplify: {
      Auth: {
        Cognito: {
          userPoolId: 'eu-west-1_vBNF4EZ4k',
          userPoolClientId: 'ahbjc11od64ofu9rjo32312f6',
        },
      },
    },
    services: {
      api: {
        baseUrl: 'https://catalog.craftcloud3d.com',
      },
      partner: {
        baseUrl: 'https://partner-api.craftcloud3d.com',
      },
      craftcloud: {
        baseUrl: 'https://craftcloud3d.com',
      },
      internal: {
        baseUrl: 'https://internal-api.craftcloud3d.com',
      },
    },
  },
  defaultConfig
)
